import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'

import Loader from '../../shared/components/Loader'
import List from '../components/List'

@inject('program')
@observer
export default class ListContainer extends Component {

  static propTypes = {
    program: PropTypes.object,
  }

  componentWillMount() {
    const { program } = this.props
    // if (!program.length && !program.collection.length) {
    program.loadPublic()
    // }
  }

  render() {

    const { program } = this.props

    return (
      <div className="vertical">
        <div
          className="vertical"
        >
          {program.loading
            ? <Loader>Programmdaten werden geladen...</Loader>
            : <List store={program} />}
        </div>
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/program/containers/List.js